export const APP_TITLE = 'Francesco Colamonici — Solution Architect & System Design'
export const APP_SITE_NAME = 'Francesco Colamonici'
export const APP_DESCRIPTION =
  'Solution Architect & System Design specialist. 15 years of enterprise experience across Fortune-30 pharma, Web3 and scaleups. TypeScript, NestJS, cloud architecture & cost optimization.'
export const APP_URL = 'https://francescocolamonici.it'
// Social/OG image: JPEG for broad scraper compatibility (WebP is unreliable on
// LinkedIn/Facebook). Versioned filename → safe to cache immutably; bump on change.
export const APP_IMAGE = 'https://francescocolamonici.it/profile-og-v1.jpg'
export const APP_LOGO = 'https://francescocolamonici.it/favicon.png'
export const APP_FAVICON = 'https://francescocolamonici.it/favicon.png'

export const APP_TWITTER = ''
export const APP_FACEBOOK = ''
export const APP_GOOGLE = ''
export const APP_YOUTUBE = ''
export const APP_INSTAGRAM = ''
export const APP_PINTEREST = ''
export const APP_LINKEDIN = 'https://www.linkedin.com/in/francesco-colamonici'
export const APP_TIKTOK = ''
export const APP_X = ''
export const APP_SNAPCHAT = ''
